module.exports = {
      id: "icon-arrow-back-usage",
      viewBox: "0 0 10 10",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-arrow-back",
      toString: function () {
        return this.url;
      }
    }